import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { companySettingsService } from '@api/services/services';
import { CheckOptionsResponse } from '@api/models/settings/CheckOptionsResponse';

type State = BaseType<CheckOptionsResponse>;

const initialState: State = {
  state: FetchState.None,
  data: {
    canCreateEstablishment: false,
    canCreateUser: false,
    canCreateTraining: false,
  },
};

export const companyChecksSlice = baseSlice({
  name: 'companyChecks',
  initialState,
});

export const selectCompanyChecksState = (state: RootState) => state.companyChecks.state;
export const selectCompanyChecksCanCreateEstablishment = (state: RootState) => state.companyChecks.data.canCreateEstablishment ?? false;
export const selectCompanyChecksCanCreateUser = (state: RootState) => state.companyChecks.data.canCreateUser ?? false;
export const selectCompanyChecksCanCreateTraining = (state: RootState) => state.companyChecks.data.canCreateTraining ?? false;
export const companyChecksActions = companyChecksSlice.actions;

export const getCompanyChecks = () => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return companySettingsService.checkOptions();
  };

  getItem({
    dispatch,
    actions: companyChecksActions,
    getData: handleGetData,
  });
};
